import { REPORTED_FIELD } from './constants';

export const COLUMNS_FILTER_PER_INTEGRATION: { [key: string]: string[] } = {
    [REPORTED_FIELD]: [
        'AFI_KAILA',
        'ASTRE_GF',
        'CEGID_FINANCES_Y2',
        'CIRIL_FINANCES',
        'JVS_FINANCES',
        'SEDIT_FINANCES_GFDE',
        'SEDIT_FINANCES',
        'SEGILOG',
        'COSOLUCE_FINANCES',
        'GRAND_ANGLE',
    ],
};

export const SOFTWARES_SUPPORTED_FOR_AP_VIEW = ['CIRIL_FINANCES', 'CORIOLIS'];
